import { SHOW_SUCCESS_BANNER } from "../../constants";

export const dismissSuccessBanner = () => dispatch => {
  dispatch({
    type: SHOW_SUCCESS_BANNER,
    payload: { showSuccessBanner: false }
  });
};
